import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Table,
} from "reactstrap";
import { format } from "date-fns";
import "./CreatorsListModal.scss";
import { getCreatorsList } from "../../../../candidate/src/helpers/backend_helper";

const CreatorsListModal = ({ selectedCandidate, isOpen, setIsOpen }) => {
  const [details, setDetails] = useState(null);
  const [names, setNames] = useState(null);

  useEffect(() => {
    if (selectedCandidate?.id) {
      getCreatorsList(
        selectedCandidate?.jobEnity?.id,
        selectedCandidate?.candidate?.id
      )
        .then((rs) => {
          setDetails(rs?.data?.creatorsDataDTOs);
          let nameOb = {};
          rs?.data?.creatorsNameDTOs?.forEach((nm) => {
            nameOb[nm[0]] = nm[1];
          });
          setNames(nameOb);
        })
        .catch((e) => {});
    }
  }, [selectedCandidate]);

  return (
    <Modal
      isOpen={isOpen}
      centered
      backdropClassName="modal"
      className="creators-list-modal"
    >
      <ModalHeader className="modal-title" toggle={() => setIsOpen(!isOpen)}>
        Creators List
      </ModalHeader>
      <ModalBody>
        <p>
          Case No: <strong>{selectedCandidate?.caseNo}</strong> | Job:{" "}
          <strong>{selectedCandidate?.jobEnity?.title}</strong> | Candidate:{" "}
          <strong>{`${selectedCandidate?.candidate?.firstName} ${selectedCandidate?.candidate?.lastName}`}</strong>
        </p>
        <Table>
          <thead>
            <tr>
              <th>#</th>
              <th>Step</th>
              <th>Creator</th>
              <th>Created Date</th>
            </tr>
          </thead>
          {details
            ?.sort((a, b) => a?.index - b?.index)
            ?.map((dt, index) => (
              <tbody key={index}>
                <tr>
                  <td>{index + 1}.</td>
                  <td>{dt?.stepName}</td>
                  <td>{names[dt?.creatorFullName]}</td>
                  <td>{format(new Date(dt.createdAt), "MMM dd, yyy")}</td>
                </tr>
              </tbody>
            ))}
        </Table>
      </ModalBody>
      <ModalFooter>
        <Button
          type="button"
          className="btn btn-white border-2 border-light-grey"
          onClick={() => setIsOpen(false)}
        >
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default CreatorsListModal;
